import { Box, useTheme } from "@mui/material"
import BaseCard from "../../../../theme/cards/BaseCard"
import { tokens } from "../../../../../theme";
import Text from "../../../../theme/text/Text";
import CardLabel from "../../../../theme/label/CardLabel";
import TopRight from "../../../../theme/positionals/TopRight";
import { useTranslation } from "react-i18next";
import ShTextSkeleton from "../../../../theme/skeleton/ShTextSkeleton";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ShDoubleTextSkeleton from "../../../../theme/skeleton/ShDoubleTextSkeleton";

const UnmatchedProductCard = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();
    
    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick} >
            <Box>
                <Box>
                    <Box 
                        display={"flex"} 
                        flexDirection={"column"} 
                        gap={props.skeleton ? 0.5 : null} 
                        width={props.skeleton ? "58%" : null}
                    >
                        {props.skeleton ?
                            <ShDoubleTextSkeleton/>
                            :
                            <>
                                <Text noBreak black>{props.sku}</Text>
                                <Text>{props.description || '-'}</Text>
                            </>
                        }
                    </Box>
                    <TopRight>
                        <CardLabel 
                            icon
                            variant={"red"}
                            // variant={"grey"}  
                            // background={theme.palette.mode === "dark" ? colors.grey[400] : null} 
                            // color={theme.palette.mode === "dark" ? colors.txt["primary"] : null} 
                            position="child-tr"
                        >
                            <PriorityHighIcon/>
                        </CardLabel>
                    </TopRight>

                    <Box marginTop={3} display={"flex"} alignItems={"flex-start"} gap={3}>
                        <Box display={"flex"} flexDirection={"column"}>

                            {props.skeleton ?
                                <ShDoubleTextSkeleton />
                                :
                                <>
                                    <Text noBreak>{props.productReference || '-'}</Text>
                                    <Text light>{props.webshop_description}</Text>
                                </>
                            }
                        </Box>
                    </Box>
                </Box>
            </Box>
        </BaseCard>
    )
}

export default UnmatchedProductCard;